import React from 'react';
import { breakpoints, Container } from '../../styles/layout';
import styled from 'styled-components';
import { rtypeN18r } from '../../styles/typography/presets';


const EmbedWrapper = styled.div`
  ${rtypeN18r};
  position: relative;
  height: 0;
  padding-bottom: ${props => props.aspectRatio || '56.25%'};
  overflow: hidden;
  > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  p {
    margin-bottom: 1.5em;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: inherit;
  }
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  ul, ol {
    margin-left: 1.5em;
    margin-bottom: 1.5em;
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
`;


const CustomContainer = styled(Container)`
  margin-bottom: 60px;
  ${EmbedWrapper} {
    grid-column: 2 / span 8;
  }

  @media(min-width: ${breakpoints.lg}) {
    margin-bottom: 90px;
  }
`;

export default ({html, embed_url, ...props}) => {
  // Prefer embed_url (Prismic oEmbed) over raw html
  if (embed_url && embed_url.html) {
    const aspectRatio = embed_url.width && embed_url.height
      ? `${(embed_url.height / embed_url.width * 100).toFixed(4)}%`
      : '56.25%';

    return (
      <CustomContainer {...props}>
        <EmbedWrapper
          aspectRatio={aspectRatio}
          dangerouslySetInnerHTML={{ __html: embed_url.html }}
        />
      </CustomContainer>
    );
  }

  return (
    <CustomContainer {...props}>
      <EmbedWrapper dangerouslySetInnerHTML={{ __html: html }} />
    </CustomContainer>
  );
};